import React, {useState,useContext,createContext,useEffect,useRef,}  from 'react'
import {Form,Button,Container,Card,Alert,Row,Col,Tabs,Tab,Navbar,Modal} from 'react-bootstrap'
import axios from 'axios'
import {UserContext} from '../UserContext'
import { tab } from '@testing-library/user-event/dist/tab'

export default function AccountingData() {

  const {accountingData,setAccountingData}=useContext(UserContext)
  const {activeTab,setActiveTab}=useContext(UserContext)
  const {countriesList,checkVatNum}=useContext(UserContext)
  const {exhibition,setExhibition}=useContext(UserContext)
  const {exhibits,setExhibits}=useContext(UserContext)
  const {items,setItems}=useContext(UserContext)
  const {temporarySave,isLoadingContact}=useContext(UserContext)
  const {oldProfiles,setOldProfiles}=useContext(UserContext)
  const {catalogueData,setCatalogueData}=useContext(UserContext)
  const {exhibitionExhibits,setExhibitionExhibits}=useContext(UserContext)
  const {sendForm}=useContext(UserContext)
  const {tempData}=useContext(UserContext)
  const {oikoi,setOikoi}=useContext(UserContext)
  const {originalAccountingData,setOriginalAccountingData}=useContext(UserContext)
  const {epimelitiria}=useContext(UserContext)

  const changeTab=(e)=>{
    e.preventDefault()
    window.scroll(0,0)
    setActiveTab('catalogue')
  }

//800385677

  const clearData=()=>{
    // setAccountingData({})
    // setExhibition({})
    // setItems([])
    // setExhibits([])
    // setExhibitionExhibits([])
    // setCatalogueData({})
    // setOldProfiles([])
    
    window.location.reload(false)

  }

  const restoreTempData=()=>{
    setAccountingData(tempData.accountingData)
    setCatalogueData(tempData.catalogueData)
    setExhibits(tempData.exhibits)
    setOikoi(tempData.oikoi)

    const allExhibits=exhibitionExhibits

    allExhibits.forEach(item0=>{
        
        if (tempData.exhibits.filter(item1=>item1.ETA30CODE==item0.ETA30CODE).length>0){
            item0.Checked=1
        }
    })
    setExhibitionExhibits(allExhibits)    


    alert("ΟΚ!")

  }


  const epimelitiriaList=epimelitiria.map(item=>{
    return(
      <option value={item.Epim}>{item.Epim}</option>
    )
  })

  return (
    <>
    
    <Alert variant='success'>
          <h4>ΣΤΟΙΧΕΙΑ ΤΙΜΟΛΟΓΗΣΗΣ // ACCOUNTING DETAILS</h4>
          </Alert>
          
          {exhibition.GLX_ExCode ? 
            <><Button variant="secondary" style={{width:'350px'}} onClick={()=>clearData()}>ΚΑΘΑΡΙΣΜΟΣ ΦΟΡΜΑΣ // CLEAR FORM</Button><hr/><br/></> : 
            ''
          }


          <Form onSubmit={changeTab}>
          <Row>
              <Col>
              <Form.Group className="mb-3">
              <Form.Label><b>ΑΦΜ // VAT NUMBER</b></Form.Label>
              <Form.Control type="text" required value={accountingData.CMTIN} onBlur={(e)=>{checkVatNum(e.target.value)}} onChange={(e)=>{setAccountingData({...accountingData, CMTIN:e.target.value})}}/>
              </Form.Group>              
              </Col>
              <Col>
              <Form.Group className="mb-3">
              <Form.Label><b>ΔΟΥ // TAX OFFICE</b></Form.Label>
              <Form.Control disabled={!accountingData.CMTIN} type="text" required value={accountingData.DOY} onChange={(e)=>{setAccountingData({...accountingData, DOY:e.target.value})}}/>
              </Form.Group>
              </Col>
            </Row>


         
          <>
          <Form.Group className="mb-3">
            <Form.Label><b>ΕΠΩΝΥΜΙΑ ΕΤΑΙΡΙΑΣ // COMPANY NAME</b></Form.Label>
            <Form.Control disabled={!accountingData.CMTIN} type="text" required value={accountingData.CMNAME}  onChange={(e)=>{setAccountingData({...accountingData, CMNAME:e.target.value})}} />
          </Form.Group>  


          <Form.Group className="mb-3">
            <Form.Label><b>ΕΠΑΓΓΕΛΜΑTIKH ΔΡΑΣΤΗΡΙΟΤΗΤΑ // PROFESIONAL SECTOR</b></Form.Label>
            <Form.Control disabled={!accountingData.CMTIN} type="text" required value={accountingData.PROFESSION}  onChange={(e)=>{setAccountingData({...accountingData, PROFESSION:e.target.value})}}   />
          </Form.Group>          

          <Form.Group className="mb-3">
          <Form.Label><b>ΧΩΡΑ // COUNTRY</b></Form.Label>
            <Form.Select disabled={!accountingData.CMTIN} required value={accountingData.COUNTRY} onChange={(e)=>{setAccountingData({...accountingData, COUNTRY:e.target.value})}}>
              <option value=''>[ΕΠΙΛΕΞΤΕ ΧΩΡΑ // SELECT COUNTRY]</option>
              {countriesList}
            </Form.Select>
          </Form.Group>


          <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label><b>ΔΙΕΥΘΥΝΣΗ // ADDRESS</b></Form.Label>
                  <Form.Control disabled={!accountingData.CMTIN} type="text" required value={accountingData.STREET} onChange={(e)=>{setAccountingData({...accountingData, STREET:e.target.value})}}/>
                </Form.Group>               
              </Col>
              <Col>
                  <Form.Group className="mb-3">
                  <Form.Label><b>ΑΡΙΘΜΟΣ // STREET NUMBER</b></Form.Label>
                  <Form.Control disabled={!accountingData.CMTIN} type="text"  value={accountingData.CMSTREETNUMBER} onChange={(e)=>{setAccountingData({...accountingData, CMSTREETNUMBER:e.target.value})}}/>
                </Form.Group>                
              
              </Col>
        </Row>

        <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label><b>ΠΟΛΗ // CITY</b></Form.Label>
                  <Form.Control disabled={!accountingData.CMTIN} type="text" required value={accountingData.CITY} onChange={(e)=>{setAccountingData({...accountingData, CITY:e.target.value})}}/>
                </Form.Group>               
              </Col>
              <Col>
                  <Form.Group className="mb-3">
                  <Form.Label><b>TK // POSTAL CODE</b></Form.Label>
                  <Form.Control disabled={!accountingData.CMTIN} type="text" required value={accountingData.CMPOSTALCODE} onChange={(e)=>{setAccountingData({...accountingData, CMPOSTALCODE:e.target.value})}}/>
                </Form.Group>                
              
              </Col>
        </Row>



        <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label><b>EMAIL</b></Form.Label>
                  <Form.Control disabled={!accountingData.CMTIN} type="email" required value={accountingData.CMEMAIL} onChange={(e)=>{setAccountingData({...accountingData, CMEMAIL:e.target.value})}}/>
                </Form.Group>               
              </Col>
              <Col>
                  <Form.Group className="mb-3">
                  <Form.Label><b>ΤΗΛΕΦΩΝΟ // TELEPHONE</b></Form.Label>
                  <Form.Control disabled={!accountingData.CMTIN} type="text" required value={accountingData.CMPHONE1} onChange={(e)=>{setAccountingData({...accountingData, CMPHONE1:e.target.value})}}/>
                </Form.Group>                
              
              </Col>
        </Row>

        <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label><b>ΓΕΜΗ</b></Form.Label>
                  <Form.Control disabled={!accountingData.CMTIN} type="text" value={accountingData.GEMI} onChange={(e)=>{setAccountingData({...accountingData, GEMI:e.target.value})}}/>
                </Form.Group>               
              </Col>
              <Col>

              
              {exhibition.NeedEpimList==1 &&
              
              <Form.Group className="mb-3">
              <Form.Label><b>ΕΠΙΜΕΛΗΤΗΡΙΟ</b></Form.Label>
              <Form.Select disabled={!accountingData.CMTIN} required value={accountingData.Epimel} onChange={(e)=>{setAccountingData({...accountingData, Epimel:e.target.value})}}>
              <option value='-'>[ΕΠΙΛΕΞΤΕ ΕΠΙΜΕΛΗΤΗΡΙΟ]</option>
              {epimelitiriaList}
              </Form.Select>              
              
              
              </Form.Group>   
              
              }
              
              </Col>
        </Row>

        <Row>

              <Col>
              {exhibition.HasRetail==1 &&
              
              <Form.Group className="mb-3">
              <Form.Label><b>ΛΙΑΝΙΚΕΣ ΠΩΛΗΣΕΙΣ / RETAIL SALES</b></Form.Label>
              <Form.Select disabled={!accountingData.CMTIN} required value={accountingData.lp} onChange={(e)=>{setAccountingData({...accountingData, lp:e.target.value})}}>
              <option value=''>[ΛΙΑΝΙΚΕΣ ΠΩΛΗΣΕΙΣ / RETAIL SALES]</option>
              <option value='0'>OXI</option>
              <option value='1'>NAI</option>
              </Form.Select>
              </Form.Group>               
              
              }
              
              </Col>

              <Col>
              
              </Col>
        </Row>

        <>  
        <br/><br/><br/><hr style={{color:'#000'}}/>
        <Navbar bg="light" fixed="bottom" >
          <table width="100%"><tbody><tr>
          <td align="left">
            {accountingData.CMTIN && 
              <Button variant="secondary" onClick={()=>sendForm(1)}>ΠΡΟΣΩΡΙΝΗ ΑΠΟΘΗΚΕΥΣΗ // TEMPORARY SAVE</Button>
            }
              
              {tempData.ISTEMP  &&
              <>&nbsp;
              
             
              <Button variant="warning" onClick={()=>{restoreTempData()}}>ΕΠΑΝΑΚΤΗΣΗ ΠΡΟΣΩΡΙΝΗΣ ΑΠΟΘΗΚΕΥΣΗΣ // RESTORE TEMPORARY SAVED DATA</Button>
              </>
              }
              </td>  
          <td align="right">
          <Button disabled={!accountingData.CMTIN} type="submit" variant="success">ΕΠΟΜΕΝΟ // NEXT</Button>
            </td></tr></tbody></table>
        </Navbar> 
        </>


          </>
          {/* <p align="right">
          <Button type="submit" variant="success">ΕΠΟΜΕΝΟ // NEXT</Button>
          </p> */}
          
          </Form>    
    
          <Modal show={isLoadingContact} backdrop="static">

                
                <Modal.Body>
                  <br/><br/><br/><br/>
                  <h4>Please Wait....</h4>
                  <br/><br/><br/><br/>

                </Modal.Body>
            </Modal>   
    </>



  );
}
